// extracted by mini-css-extract-plugin
module.exports = {"thankYou":"ThankYou-module__thankYou___1kBxR","note":"ThankYou-module__note___3-3hy","close":"ThankYou-module__close___1wynw","button":"ThankYou-module__button___3Jm1A"};